/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
    $(form).find('.radio-choose.is-invalid').removeClass('is-invalid');
}

module.exports = function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $('.alert', formElement).remove();

    if (typeof payload === 'object' && payload.fields) {
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                var feedbackElement = $(formElement).find('[name="' + key + '"]')
                    .parent()
                    .children('.invalid-feedback');

                if (feedbackElement.length > 0) {
                    if (Array.isArray(payload[key])) {
                        feedbackElement.html(payload.fields[key].join('<br/>'));
                    } else {
                        feedbackElement.html(payload.fields[key]);
                        // display error message for pasword input from hidden password confirm, when password does not match regex rule
                        var confirmPasswordError = $(formElement).find('[name$=_passwordconfirm]').parent().children('.invalid-feedback').text();
                        $(formElement).find('[name$=_password]').addClass('is-invalid');
                        $(formElement).find('[name$=_password]').parent().children('.invalid-feedback').html(confirmPasswordError);
                    }
                    feedbackElement.siblings('.form-control').addClass('is-invalid');

                    var radioChoose = feedbackElement.parents('.radio-choose');
                    if (radioChoose.length != 0) {
                        radioChoose.addClass('is-invalid');
                        radioChoose.children('.radio-feedback').html(payload.fields[key]);
                    }
                }
            }
        });
    }
    if (payload && payload.error) {
        var form = $(formElement).prop('tagName') === 'FORM'
            ? $(formElement)
            : $(formElement).parents('form');
        if (Array.isArray(payload.error))
            form.prepend('<div class="alert alert-danger" role="alert">'+ payload.error.join('<br/>') + '</div>');
    }
};
